import { TableCell, withStyles } from "@material-ui/core";
import Clear from "@material-ui/icons/Clear";
import HasPermissionTo from "../../../common/HasPermissionTo";
import styles from "../../../components/pricing/pricingWrapper/pricingHeader/PricingHeader.module.scss";
import Item from "../../item/Item";
import Button from "@material-ui/core/Button";
import React from "react";
import CheckIcon from "@material-ui/icons/Check";

export const StyledClear = withStyles({
  root: {
    width: 20,
    height: 20,
    fill: "#e81607",
  },
})(Clear);

export const StyledCheckIcon = withStyles({
  root: {
    width: 20,
    height: 20,
    fill: "#1d9d01",
  },
})(CheckIcon);

const StyledButton = withStyles({
  root: {
    minWidth: 50,
  },
})(Button);

export const CheckBoxTableCell = withStyles({
  root: {
    borderBottom: 0,
    padding: 0,
    width: "3%",
  },
})(TableCell);

export const CheckBoxTableCellHeader = withStyles({
  root: {
    paddingBottom: 10,
    verticalAlign: "bottom",
  },
})(CheckBoxTableCell);

export const WarningTableCell = withStyles({
  root: {
    padding: 0,
    width: "3.5%",
  },
})(TableCell);

export const SpecsTableCell = withStyles({
  root: {
    borderBottom: 0,
    fontWeight: 500,
    padding: "5px 10px",
    width: "25%",
    textAlign: "left",
    color: "#102b4e",
    fontSize: "12px",
    fontFamily: "FordAntennaRegular, sans-serif",
    letterSpacing: "1px",
    lineHeight: 2.5,
  },
})(TableCell);

export const SpecsTableHeader = withStyles({
  root: {
    fontFamily: "FordAntennaSemiBold, sans-serif",
    lineHeight: 1,
    textTransform: "uppercase",
    verticalAlign: "bottom",
  },
})(SpecsTableCell);

export const NonEditTableCell = withStyles({
  root: {
    borderBottom: 0,
    fontWeight: 500,
    padding: "5px 10px",
    width: "13%",
    textAlign: "right",
    color: "#4a4a4a ",
    fontSize: "12px",
    letterSpacing: "1px",
    fontFamily: "FordAntennaSemiBold, sans-serif",
  },
})(TableCell);

export const NonEditTableHeader = withStyles({
  root: {
    width: "13%",
    fontFamily: "FordAntennaCondMed, sans-serif",
    textTransform: "uppercase",
    verticalAlign: "bottom",
    textAlign: "right",
  },
})(NonEditTableCell);

export const SpecsTableHeaderPricingDetails = withStyles({
  root: {
    width: "15%",
  },
})(SpecsTableHeader);

export const SpecsTableCellPricingDetails = withStyles({
  root: {
    width: "15%",
  },
})(SpecsTableCell);

export const PermissionHeader = (props) => {
  return (
    <NonEditTableHeader>
      <HasPermissionTo
        permissions={props.user.permissions.rolePermissions}
        perform={["vehiclePricing:write"]}
        condition={props.condition}
        render={() =>
          props.editEnabled ? (
            <>
              <div>
                <div
                  data-testid={props.headerTestId}
                  className={styles.vehiclesHeaderUpdate}
                >
                  <Item value={props.headerText} />
                </div>
              </div>
              <div className={styles.vehiclesHeaderWrap}>
                <StyledButton
                  size="small"
                  name="Cancel"
                  data-testid={props.cancelTestId}
                  onClick={() => {
                    props.cancelChanges();
                  }}
                >
                  <StyledClear />
                </StyledButton>
                <StyledButton
                  size="small"
                  name="Confirm"
                  type="submit"
                  data-testid={props.confirmTestId}
                >
                  <StyledCheckIcon data-testid="updateCheckIcon" />
                </StyledButton>
              </div>
            </>
          ) : (
            <div className={styles.vehiclesHeaderWrap}>
              <span>
                <Item value={props.bodyText} />
              </span>
              <div>
                <div
                  className={styles.Edit}
                  onClick={(e) => {
                    props.editRecords(e);
                  }}
                  data-testid={props.editTestId}
                >
                  <div className={styles.RectangleStart} />
                  <div className={styles.RectangleEnd} />
                </div>
              </div>
            </div>
          )
        }
        noRender={() => (
          <div className={styles.vehiclesHeaderWrap}>
            <Item value={props.noRenderText} />
          </div>
        )}
      />
    </NonEditTableHeader>
  );
};
